module.exports = __webpack_public_path__ + "static/install.cad9ee34.png";